module.exports = __webpack_public_path__ + "img/frase.7875d0ce.png";